import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import React from 'react';

import { space } from '@/styles';

import MemberTile from './MemberTile';

const style = {
  membersList: css`
    display: flex;
    flex-wrap: wrap;
    margin: -10px;
  `,
};

const CommitteeMembers = ({ members, route, enableBio, showPosition }) => {
  return (
    <div css={[space.m.b16, style.membersList]}>
      {members.map(member => (
        <MemberTile
          key={member.PersonId}
          member={member}
          route={route}
          enableBio={enableBio}
          showPosition={showPosition}
        />
      ))}
    </div>
  );
};

CommitteeMembers.propTypes = {
  members: PropTypes.array,
};

CommitteeMembers.defaultProps = {
  members: [],
};

export default CommitteeMembers;
